/* eslint-disable no-console */
import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING } from "const"
import { StateType, useInput } from "client/utils"
import { QUERY } from "client/store/utils"
import { StoreType } from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    FormGroup,
    CheckButton,
    Label,
    Textarea,
    Delimiter,
    Button,
    SpinnerIcon,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"

let sqlArray: string[]
let index: number

const labelStyle = { color: "orangered" }
const texareaStyle = { minHeight: "150px" }

const MtSqlExecutor = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [multiSql, setMultiSql] = useInput("")
    const [singleSql, setSingleSql] = useInput("")

    const [showResult, setShowResult] = useState(false)
    const [showMetadata, setShowMetadata] = useState(true)

    const [multiState, setMultiState] = useState<StateType>(IDLE)
    const [singleState, setSingleState] = useState<StateType>(IDLE)


    const executeMulti = () => {
        setMultiState(PENDING)
        sqlArray = multiSql.split("\n").filter((row) => row.trim().length > 0)
        index = 0

        multiQuery()
    }

    const multiQuery = () => {
        const rowSql = sqlArray[index]
        if (rowSql) {
            QUERY(rowSql).then((res) => {
                if (res.error) {
                    console.log(res.error)
                } else {
                    const [results, metadata] = res
                    if (showResult && showMetadata) console.log(results, metadata)
                    else if (showResult) console.log(results)
                    else if (showMetadata) console.log(metadata)
                }

                index += 1
                multiQuery()
            })
        } else {
            setMultiState(IDLE)
        }
    }

    const executeSingle = () => {
        setSingleState(PENDING)
        QUERY(singleSql).then((res) => {
            if (res.error) {
                console.log(res.error)
            } else {
                const [results, metadata] = res
                if (showResult && showMetadata) console.log(results, metadata)
                else if (showResult) console.log(results)
                else if (showMetadata) console.log(metadata)
            }

            setSingleState(IDLE)
        })
    }

    if (userData.accountId !== 1) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.sqlExecutor}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <p>
                                <b>ATTENTION! Changes cannot be undone!</b>
                                <br />
                                Results in the browser console.
                            </p>

                            <Delimiter />

                            <Label>Result format</Label>
                            <FormGroup>
                                <CheckButton
                                    checked={showResult}
                                    onChange={() => setShowResult(!showResult)}
                                    title="Result"
                                />
                            </FormGroup>
                            <FormGroup>
                                <CheckButton
                                    checked={showMetadata}
                                    onChange={() => setShowMetadata(!showMetadata)}
                                    title="Metadata"
                                />
                            </FormGroup>
                        </Col>


                        <Col xs={12}>
                            <Delimiter />

                            <p>
                                Multi-row handles an array of simple queries like SELECT, UPDATE, DELETE, ALTER.
                                <br />
                                Each query must be on new line.
                            </p>

                            <FormGroup>
                                <Label style={labelStyle}>Multi-Row Sql</Label>
                                <Textarea
                                    value={multiSql}
                                    onChange={setMultiSql}
                                    style={texareaStyle}
                                />
                            </FormGroup>

                            <Button variant="success" onClick={executeMulti}>
                                {multiState === PENDING ? <SpinnerIcon /> : lang.execute}
                            </Button>
                        </Col>

                        <Col xs={12}>
                            <Delimiter />

                            <p>
                                Single-row handles only simple queries.
                                <br />
                                <b>To create procedure do not use DELIMETER</b>
                                <br />
                                CREATE PROCEDURE ...proc_name... BEGIN ...proc_body... END
                            </p>

                            <FormGroup>
                                <Label style={labelStyle}>Single-Row Sql</Label>
                                <Textarea
                                    value={singleSql}
                                    onChange={setSingleSql}
                                    style={texareaStyle}
                                />
                            </FormGroup>

                            <Button variant="success" onClick={executeSingle}>
                                {singleState === PENDING ? <SpinnerIcon /> : lang.execute}
                            </Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default MtSqlExecutor
